import { StaffContractInfoDto } from '@siza-staff-care/shared/data';
import { formatDateRange } from './date-time-formatters';

export const formatStaffContract = (contract: StaffContractInfoDto) => {
	return formatDateRange(contract.startDate, contract.endDate);
};
